import { Link } from '@/i18n/navigation'
import { ArrowRight } from '@/components/ui/icons'

const logo = (name: string) => `/marketing/logos-mono/${name}.svg`

// ponytail: hand-picked from the offered catalog (marketing-config). Revisit when a
// headline model ships; the full list lives on /supported-models.
// Motion graphics are written as code, so that row lists the language models that write them.
const GROUPS: { label: string; models: { name: string; src: string }[] }[] = [
  {
    label: 'Video',
    models: [
      { name: 'Seedance 2.5', src: logo('bytedance') },
      { name: 'MiniMax H3', src: logo('minimax') },
      { name: 'Kling O3', src: logo('kling') },
      { name: 'FLUX.3', src: logo('bfl') },
      { name: 'Wan 3.0', src: logo('qwen') },
      { name: 'Grok Imagine', src: logo('grok') },
      { name: 'Veo 3.1', src: logo('gemini') },
      { name: 'Ray 3.2', src: logo('luma') },
    ],
  },
  {
    label: 'Image',
    models: [
      { name: 'Nano Banana Pro', src: logo('gemini') },
      { name: 'GPT Image 2.5', src: logo('openai') },
      { name: 'Flux 2 Max', src: logo('bfl') },
      { name: 'Seedream 5 Pro', src: logo('bytedance') },
    ],
  },
  {
    label: 'Audio',
    models: [
      { name: 'ElevenLabs v3', src: logo('elevenlabs') },
      { name: 'Lyria 3.5', src: logo('gemini') },
      { name: 'MiniMax Music 3', src: logo('minimax') },
      { name: 'Stable Audio 2.5', src: logo('stability') },
    ],
  },
  {
    label: 'Motion graphics',
    models: [
      { name: 'Claude Opus', src: logo('claude') },
      { name: 'GPT-6 Astra', src: logo('openai') },
      { name: 'Claude Fable', src: logo('claude') },
    ],
  },
]

export function ProductionModels() {
  return (
    <div className="p-5 md:p-6">
      {GROUPS.map(group => (
        <div
          key={group.label}
          className="grid gap-3 border-t border-white/[0.07] py-5 first:border-t-0 first:pt-0 sm:grid-cols-[96px_1fr]"
        >
          <p className="text-[12px] uppercase tracking-[0.1em] text-white/35 sm:pt-3">{group.label}</p>
          <ul className="grid grid-cols-2 gap-2 md:grid-cols-4">
            {group.models.map(model => (
              <li
                key={model.name}
                className="flex items-center gap-3 rounded-lg border border-white/[0.08] bg-white/[0.02] px-3 py-2.5"
              >
                {/* eslint-disable-next-line @next/next/no-img-element -- static brand mark */}
                <img src={model.src} alt="" className="h-5 w-5 shrink-0 object-contain" />
                <span className="min-w-0 text-[13px] font-medium leading-tight text-white/90">{model.name}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="grid gap-3 border-t border-white/[0.07] pt-5 sm:grid-cols-[96px_1fr]">
        <p className="text-[12px] uppercase tracking-[0.1em] text-white/35">And more</p>
        <Link
          href="/supported-models"
          className="group inline-flex items-center gap-1.5 text-[14px] text-white/60 transition-colors hover:text-white"
        >
          See every supported model
          <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" />
        </Link>
      </div>
    </div>
  )
}
